import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	popover: {
		pointerEvents: 'none'
	},
	paper: {
		padding: theme.spacing(1)
	},
	button: {
		backgroundColor: theme.palette.info,
		color: '#5bc0de',
		position: 'absolute',
		right: '5%',
		cursor: 'pointer'
	}
}));

const HelpToolTip = ({ title, instructions }) => {
	let list = instructions.map((v, i) => <ListItem key={i}>{v}</ListItem>);

	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handlePopoverOpen = event => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	return (
		<>
			<IconButton
				title={title}
				className={classes.button}
				aria-owns={open ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onKeyPress={handlePopoverOpen}
				onMouseEnter={handlePopoverOpen}
				onMouseLeave={handlePopoverClose}
				aria-label='Help Tooltip'
			>
				<InfoOutlinedIcon />
			</IconButton>
			<Popover
				id="mouse-over-popover"
				className={classes.popover}
				classes={{
					paper: classes.paper
				}}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'center',
					horizontal: 'left'
				}}
				transformOrigin={{
					vertical: 'center',
					horizontal: 'right'
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
				role='tooltip'
			>
				<List
					component="div"
					aria-labelledby={title}
					subheader={
						<ListSubheader component="div" id="nested-list-subheader">
							{title}
						</ListSubheader>
					}
				>
					{list}
				</List>
			</Popover>
		</>
	);
};

HelpToolTip.propTypes = {
	title: PropTypes.string.isRequired,
	instructions: PropTypes.array
};

HelpToolTip.defaultProps = {
	instructions: ['Double Click to edit a field.', 'Sort by clicking the column header.']
};

export default HelpToolTip;
